import 'liquid-ajax-cart'

import Alpine from 'alpinejs'
import AlpineCollapse from '@alpinejs/collapse'
import AlpineFocus from '@alpinejs/focus'
import AlpineMorph from '@alpinejs/morph'
import AlpineIntersect from '@alpinejs/intersect'
import AlpineGlobals from '../js/alpine/index.ts'
import helpers from '../js/helpers.js'

// import barba from '@barba/core'

import '../js/orsay/stories.js'

// Uncomment to use to load the dynamic script demo
// hasBodyClass('product-template') && import('../js/dynamicScript')

window.orsay = window.orsay || {}
window.orsay.helpers = helpers

for (const [key, value] of Object.entries(helpers)) {
	window.orsay.helpers[key] = value
}

// Register and initialize AlpineJS
window.Alpine = Alpine

Alpine.plugin([AlpineCollapse, AlpineFocus, AlpineMorph, AlpineIntersect])
AlpineGlobals.register(Alpine)
Alpine.start()

// Hide the Shopify preview bar in development
if (import.meta.env.DEV) {
	window.addEventListener('DOMContentLoaded', () => {
		const css = '#preview-bar-iframe { display: none !important; }'
		const headEl = document.head || document.getElementsByTagName('head')[0]
		const styleEl = document.createElement('style')

		headEl.appendChild(styleEl)

		styleEl.appendChild(document.createTextNode(css))
	})
}

if (history.scrollRestoration) {
	history.scrollRestoration = 'manual'
}

// barba.init()

// barba.hooks.afterEnter(() => {
// 	window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
// })
